import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { getComments } from "../redux/apiCalls";
import {
  AddCommentFailure,
  AddCommentStart,
  AddCommentSuccess,
} from "../redux/commentSlice";
import { userRequest } from "../requestMethods";

import Comment from "./Comment";

const Container = styled.div``;
const NewComment = styled.div`
  display: flex;
  flex-direction: column;
`;
const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;
const Input = styled.input`
  border: none;
  outline: none;
  background-color: transparent;
  border-bottom: 2px solid ${({ theme }) => theme.soft};
  padding: 5px;
  width: 100%;
  color: ${({ theme }) => theme.text};
`;
const Button = styled.button`
  background-color: #007acc;
  font-weight: 500;
  color: white;
  border: none;
  border-radius: 3px;
  width: max-content;
  height: max-content;
  padding: 10px 20px;
  align-self: flex-end;
  cursor: pointer;
`;

const Comments = ({ videoId }) => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentComments } = useSelector((state) => state.comment);
  // const [comments, setComments] = useState([]);
  const [comment, setComment] = useState("");

  const dispatch = useDispatch();

  // useEffect(() => {
  //   const fetchComments = async () => {
  //     try {
  //       const res = await axios.get(`/comments/${videoId}`);
  //       setComments(res.data);
  //     } catch (err) {}
  //   };
  //   fetchComments();
  // }, [videoId]);

  useEffect(() => {
    getComments(videoId, dispatch);
  }, [videoId, dispatch]);

  const handleClick = async (e) => {
    e.preventDefault();
    dispatch(AddCommentStart());
    try {
      const res = await userRequest.post("/comments/", { videoId, desc: comment });
      dispatch(AddCommentSuccess(res.data));
      setComment("");
    } catch (err) {
      dispatch(AddCommentFailure());
    }
  };

  return (
    <Container>
      {currentUser && (
        <NewComment>
          <Content>
            <Avatar
              src={
                currentUser?.img
                  ? currentUser?.img
                  : "https://refugedulacdulou.com/wp-content/uploads/2019/01/avatar-anonyme.png"
              }
            />
            <Input
              placeholder="Add a comment ..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Content>
          {comment && <Button onClick={handleClick}>Add a Comment</Button>}
        </NewComment>
      )}
      {currentComments?.map((comment) => (
        <Comment
          key={comment._id}
          comment={comment}
          currentUser={currentUser}
        />
      ))}
    </Container>
  );
};

export default Comments;
